<script setup>
import Markdown from 'vue3-markdown-it'
import Image from '@/components/Image.vue'
const props = defineProps({
  content: Object
})
const DEFAULT_COLOR = 'primary'

const bgClassesMap = {
  primary: 'bg-mnet rounded-standard box-shadow-standard',
  white: 'bg-white'
}
const bgClasses = bgClassesMap[props.content.backgroundColor || DEFAULT_COLOR]

const textColorMap = {
  primary: 'text-white',
  white: 'text-mnet'
}
const textClass = textColorMap[props.content.backgroundColor || DEFAULT_COLOR]

const buttonClassesMap = {
  primary: 'bg-mnet text-white hover:bg-white hover:text-mnet border-white hover:border-primary',
  white: 'bg-white text-mnet hover:bg-mnet hover:text-white border-primary hover:border-white'
}
const buttonClasses = buttonClassesMap[props.content.buttonColor || DEFAULT_COLOR]
</script>

<template>
  <div :class="`flex flex-col items-center py-4 px-6 mb:8 sm:mb-12 ${bgClasses}`">
    <div v-if="content.kicker" :class="`${textClass} text-sm mb-4`">
      {{ content.kicker }}
    </div>
    <Image v-if="content.ctaImage.data" :content="content.ctaImage.data.attributes" class-list="mb-4 md:mb-2" />
    <Markdown v-if="content.ctaBody"
      :class="`${textClass} prose text-white mb-6 text-center leading-6 text-base sm:text-lg lg:leading-7 lg:text-xl`"
      :source="content.ctaBody"
      :html="true" />
    <a v-if="content.link" :href="content.link"
      :class="`${buttonClasses} cta-link py-1 px-12 my-3 rounded-3xl text-base lg:text-lg font-extrabold border border-x-2 border-y-1`">
      {{ content.button_text }}
    </a>
  </div>
</template>


<style lang="scss" scoped>
.cta-link {
  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
}
</style>